// Utility helpers for Insights page to keep component lean

// Pool describing all possible filters (with category applicability)
export const initialFilterPool = [
	{ key: 'date_preset', label: 'Date Range', cat: 'both' },
	{ key: 'granularity', label: 'Granularity', cat: 'both' },
	{ key: 'currency', label: 'Currency', cat: 'transactions' },
	{ key: 'status', label: 'Transaction Status', cat: 'transactions' },
	{ key: 'lounge_id', label: 'Lounge', cat: 'transactions' },
	{ key: 'user_id', label: 'User', cat: 'transactions' },
	{ key: 'subscription_status', label: 'Subscription Status', cat: 'subscriptions' },
	{ key: 'plan_tier', label: 'Plan Tier', cat: 'subscriptions' },
	{ key: 'metric', label: 'Metric', cat: 'both' }
];

export function filterPoolForCategory(category) {
	return initialFilterPool.filter(f => f.cat === 'both' || f.cat === category);
}

export function buildTxQuery(filtersState) {
	const params = new URLSearchParams();
	params.set('granularity', filtersState.granularity || 'month');
	if (filtersState.date_preset) params.set('date_preset', filtersState.date_preset);
	if (filtersState.currency) params.set('currency', filtersState.currency);
	if (filtersState.status) params.set('status', filtersState.status);
	if (filtersState.lounge_id) params.set('lounge_id', filtersState.lounge_id);
	if (filtersState.user_id) params.set('user_id', filtersState.user_id);
	return `/api/insights/transactions/aggregate?${params.toString()}`;
}

export function buildSubQuery(filtersState) {
	const params = new URLSearchParams();
	params.set('granularity', filtersState.granularity || 'month');
	if (filtersState.date_preset) params.set('date_preset', filtersState.date_preset);
	if (filtersState.subscription_status) params.set('status', filtersState.subscription_status);
	if (filtersState.plan_tier) params.set('plan_tier', filtersState.plan_tier);
	return `/api/insights/subscriptions/aggregate?${params.toString()}`;
}

export function txSeriesChartData(txData, metric) {
	if (!txData) return [];
	if (metric === 'transaction_amount') {
		return txData.series.map(s => ({ name: s.bucket.substring(0,10), value: s.amount_sum }));
	}
	if (metric === 'transaction_count') {
		return txData.series.map(s => ({ name: s.bucket.substring(0,10), value: s.count }));
	}
	return [];
}

// Subscription series data (count only for now)
export function subSeriesChartData(subData) {
	if (!subData) return [];
	return subData.series.map(s => ({ name: s.bucket.substring(0,10), value: s.count }));
}

export function defaultMetricForCategory(category) {
	return category === 'transactions' ? 'transaction_amount' : 'subscription_count';
}
